import React from "react";

import "../styles.scss";
import "../scripts";

import {
  KameleonElement,
  primaryCollectionBlock,
  getDefaultProps,
} from "@kameleon-core/lib";
import { Box } from "theme-ui";
import {
  Variants,
  BackgroundColors as ThemeBackgroundColors,
  backgroundColorModeMapper,
} from "@kameleon-util/global-theme";
import {
  blockConfig,
  ContentCollectionItem,
  ContentCollectionItemType,
} from "./components/content-collection-item";

import blockinfo from "./blockinfo.json";
import defaults from "./defaults.json";
import {
  ContentCollectionType as ComponentType,
  layoutOptions,
} from "./types/prop-types";

type ContentCollectionType = {
  PrimaryBlocks: ContentCollectionItemType[];
} & ComponentType;

let applyDefaultColor = false;

export const ContentCollection = primaryCollectionBlock<ContentCollectionType>(
  blockConfig,
  ({ PrimaryBlocks, image, layoutProps }: ContentCollectionType) => {
    const primaryBlockLayoutProps = { ...layoutProps };
    if (image.url) {
      applyDefaultColor = false;
      primaryBlockLayoutProps.backgroundColor = ThemeBackgroundColors.none;
      layoutProps.backgroundColor = ThemeBackgroundColors.none;
    } else if (!applyDefaultColor) {
      applyDefaultColor = true;
      primaryBlockLayoutProps.backgroundColor = ThemeBackgroundColors.neutral;
      layoutProps.backgroundColor = ThemeBackgroundColors.neutral;
    }
    return (
      <Box className="primary-collection-content-collection-two-col-text-columns-media-v1">
        <Box className="section_layout123">
          <Box className="padding-global container-large padding-section-large w-layout-grid layout123_component">
            {PrimaryBlocks?.map((primaryBlockProps, i) => {
              const primaryProps = { ...primaryBlockProps };
              primaryProps.layoutProps = primaryBlockLayoutProps;
              primaryProps._parentBgColor = backgroundColorModeMapper(
                layoutProps.backgroundColor
              ).color;
              return <ContentCollectionItem key={i} {...primaryProps} />;
            })}
          </Box>
          <Variants.OpacityWrapper className="layout123_background-image-wrapper">
            <Variants.OpacityLayer className="image-overlay-layer" />
            <Variants.ImageNoRadius
              src={image.url}
              loading="lazy"
              alt={image.alt}
              className="layout123_background-image"
            />
          </Variants.OpacityWrapper>
        </Box>
      </Box>
    );
  }
);

ContentCollection.defaultProps =
  getDefaultProps<ContentCollectionType>(defaults);

export const Element: KameleonElement = {
  component: ContentCollection,
  blockInfo: blockinfo,
  defaultProps: {
    layoutProps: defaults.layoutProps,
    contentProps: defaults.contentProps,
  },
  layoutOptions,
};
